import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useAgGridCommon } from 'common/table/agGrid/AgGridCommon';
import { common } from 'utils/agGrid/options';
import { useAppSelector } from 'hooks/useAppSelector';
import { createLoadingSelector } from 'erisxkit/client';
import { ACCOUNTS } from 'constants/actionTypes';
interface ReconciliationGridProps {
  data: ReconciliationDataType[];
  colDefs: ColDef[];
  viewReconciliations: (id: string) => void;
}

export interface ReconciliationDataType {
  firmCode: string;
  accountCode: string;
  accountId: string;
  accountName: string;
  subExchangeLabel: string;
  provider: string;
  providerAccountId: string;
  fundsDesignation: string;
  assetType: string;
  amount: string;
  balances: object;
  categories: string[];
  name: string;
  type: string;
}

export const gridName = 'reconciliation';

const ReconciliationGrid: React.FC<ReconciliationGridProps> = ({
  data,
  colDefs,
  viewReconciliations,
}) => {
  const gridRef = useRef<AgGridReact>(null);
  const [rowData, setRowData] = useState<ReconciliationDataType[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);

  useEffect(() => {
    setColumnDefs(colDefs);
  }, [colDefs]);

  const { gridVisible, initialGridSettings, onStateUpdated } = useAgGridCommon({
    gridName,
  });

  useEffect(() => {
    setRowData(data);
  }, [data]);

  const loading = useAppSelector((state) =>
    createLoadingSelector([ACCOUNTS])(state),
  );

  const onRowClicked = useCallback(() => {
    const selectedRows = gridRef.current?.api.getSelectedRows();
    //We can select just 1 row at time in this table.
    if (selectedRows) viewReconciliations(selectedRows[0]?.accountId || '');
  }, [viewReconciliations]);

  return (
    <div className="ag-theme-quartz">
      {gridVisible && (
        <AgGridReact
          loading={loading}
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          gridOptions={common}
          onStateUpdated={onStateUpdated}
          initialState={initialGridSettings}
          onRowClicked={onRowClicked}
        />
      )}
    </div>
  );
};

export default ReconciliationGrid;
